var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"leek-preview"},[_c('leek-image',{attrs:{"leek":{level: 30, hat: _vm.hat.id},"scale":0.55}}),_c('leek-image',{attrs:{"leek":{level: 90, hat: _vm.hat.id},"scale":0.65}}),_c('leek-image',{attrs:{"leek":{level: 250, hat: _vm.hat.id},"scale":0.7}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }